function getModalStyle (config) {
    if (config.position === "center" || !config.targetRect) {
        return {};
    }

    const { targetRect } = config;
    const style = {
        position: "absolute"
    };
    
    const gap = 20;

    switch (config.position) {
        case "top":
            style.left = `${targetRect.left + targetRect.width / 2 + 10}px`;
            style.bottom = `${window.innerHeight - targetRect.top + gap}px`;
            style.transform = "translateX(-50%)";
            break;

        case "bottom":
            style.left = `${targetRect.left + targetRect.width / 2 + 10}px`;
            style.top = `${targetRect.bottom + gap}px`;
            style.transform = "translateX(-50%)";
            break;

        case "left":
            style.right = `${window.innerWidth - targetRect.left + gap}px`;
            style.top = `${targetRect.top + targetRect.height / 2}px`;
            style.transform = "translateY(-50%)";
            break;

        case "right":
            style.left = `${targetRect.right + gap + 10}px`; // Add extra 10px for right shift
            style.top = `${targetRect.top + targetRect.height / 2}px`;
            style.transform = "translateY(-50%)";
            break;

        default:
            break;
    }

    return style;
}

export {
    getModalStyle
};
